export const AccessLevelModal: string = 'AccessLevelModal';
